import { DroneCode } from "../droneSpecification/droneSpec.code";
import { DroneSpecificationDto } from "../droneSpecification/droneSpecification.dto";
import { UnitDto } from "../unit/unit.dto";

export class FlightConfigurationDto {
    public seq!: number;
    public droneSpecSeq!: number;
    public manufacturer!: string;
    public name!: string;
    public minimumTemperature!: number;
    public maximumTemperature!: number;
    public windResistance!: number;
    public minimumHumidity!: number;
    public maximumHumidity!: number | null;
    public satelliteCount!: number;
    public cloudCover!: number;
    public visibility!: number;
    public precipitation!: number;
    public accountSeq!: number;

    public setDroneSpecificationDtoInfo(droneSpecifationDto: DroneSpecificationDto): void {
        this.droneSpecSeq = droneSpecifationDto.seq;
        this.manufacturer = droneSpecifationDto.manufacturer;
        this.name = droneSpecifationDto.name;
        this.minimumHumidity = 0;

        if (droneSpecifationDto.seq != DroneCode.CUSTOM_DRONE) {
            this.minimumTemperature = droneSpecifationDto.minimumTemperature;
            this.maximumTemperature = droneSpecifationDto.maximumTemperature;
            this.windResistance = droneSpecifationDto.windResistance;

            this.maximumHumidity = null;
        }

        if (droneSpecifationDto.seq == DroneCode.DS30) {
            this.minimumHumidity = droneSpecifationDto.minimumHumidity;
            this.maximumHumidity = droneSpecifationDto.maximumHumidity;
        }
    }

    public setValuesAtUserUnit(unit: UnitDto): void {
        if (this.windResistance) {
            this.windResistance = unit.convertCalculatedWindSpeed(this.windResistance);
        }

        if (this.minimumTemperature) {
            this.minimumTemperature = unit.convertCalculatedTemperature(this.minimumTemperature);
        }

        if (this.maximumTemperature) {
            this.maximumTemperature = unit.convertCalculatedTemperature(this.maximumTemperature);
        }

        if (this.visibility) {
            this.visibility = unit.convertCalculatedDistance(this.visibility);
        }
    }

    public setValuesAtDefaultUnit(unit: UnitDto): void {
        if (this.windResistance) {
            this.windResistance = unit.convertDefaultWindSpeed(this.windResistance);
        }

        if (this.minimumTemperature) {
            this.minimumTemperature = unit.convertDefaultTemperature(this.minimumTemperature);
        }

        if (this.maximumTemperature) {
            this.maximumTemperature = unit.convertDefaultTemperature(this.maximumTemperature);
        }

        if (this.visibility) {
            this.visibility = unit.convertDefaultDistance(this.visibility);
        }
    }
}
